import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-line-credits',
  templateUrl: './order-line-credits.component.html',
  styleUrls: ['./order-line-credits.component.css']
})
export class OrderLineCreditsComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public selectListSelectionIds: SelectionIdItem[] = [];

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(2756, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadSelectionIds() {
        this.selectListSelectionIds = await this.datatask.Post(2759);
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId(this.setting.view_id)
                .setLoadDataFunction({
                    method: this.setting.p2_datatask_keyno,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'orderlinecredits_selection_id':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadSelectionIds();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    page_heading: string;
    argtype: string;
    argvalue: string;
    view_id: string;
    p2_datatask_keyno: number;
    orderlinecredits_selection_id: string;
}

interface SelectionIdItem {
    orderlinecredits_selection_id: string;
    orderlinecredits_selection_name: string;
    orderby: number;
}
